module.exports = __webpack_public_path__ + "img/img-setting.d261c8bd.png";